export default "__VITE_ASSET__75327cf7__$_?nuxt_component=async__"